/* Sized to the `completed/total` caption it replaces (`stage-header.module.scss`), so swapping
   one for the other does not change the row header's height. */
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: none;
  border-radius: 0.4rem;
  background: transparent;
  color: #8a8f98;
  cursor: pointer;

  svg {
    width: 1.4rem;
    height: 1.4rem;
  }

  &:hover {
    background-color: var(--color-surfaces-app-background-2, #2c2d31);
    color: #fff;
  }

  &:focus-visible {
    outline: 1px solid var(--color-texts-high-contrast, #fff);
    outline-offset: 1px;
  }
}
